import Vue from 'vue'
import Meta from 'vue-meta'
import VueRouter from 'vue-router'
import configs from '@/configs'
import store from '@/store'
import routes from './pathes'

Vue.use(VueRouter)

const router = new VueRouter({
    base: import.meta.env.BASE_URL,
    mode: 'history',
    routes,
    scrollBehavior(to, _from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        }
        if (to.hash) {
            return { selector: to.hash }
        }

        return { x: 0, y: 0 }
    },
})

Vue.use(Meta)

router.beforeEach((to, _from, next) => {
    if (to.name === 'Login') {
        if (store.getters['auth/getHash']) {
            return router.push('/modules')
        }
    }

    next()
})

const systemName = configs.system.charAt(0).toUpperCase() + configs.system.slice(1).toLowerCase()
const defaultTitle = `Portal ${systemName} - ZNAP Technologies`

router.afterEach((to) => {
    Vue.nextTick(() => {
        document.title = to.meta.title ? `${to.meta.title} - ${defaultTitle}` : defaultTitle
    })
})

export default router
